import React from 'react';
export var DefaultCardArt = _ref => {
  var {
    title
  } = _ref;
  return React.createElement("svg", {
    "aria-labelledby": "default-card-art-title",
    "data-testid": "default-card-art",
    height: "25",
    role: "img",
    viewBox: "0 0 38 25",
    width: "38",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", {
    id: "default-card-art-title"
  }, title), React.createElement("path", {
    d: "M5.656 7.2H36v15.333c0 .81-.635 1.467-1.42 1.467H1.935c-.783 0-1.42-.657-1.42-1.467V1.989c0-.81.637-1.467 1.42-1.467H34.58c.784 0 1.419.657 1.419 1.467v1.587",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#6C7378",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default DefaultCardArt;